// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

function container(theme, themeType) {
  var match = theme.components;
  var iconCard = match.iconCard;
  var iconCardTheme = themeType ? iconCard.light : iconCard.dark;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.borderRadius(iconCardTheme.borderRadius),
              BsCssJs$PrezzeeRibbon.backgroundColor(iconCardTheme.backgroundColor),
              BsCssJs$PrezzeeRibbon.padding4(BsCssJs$PrezzeeRibbon.px(32), BsCssJs$PrezzeeRibbon.px(32), BsCssJs$PrezzeeRibbon.px(39), BsCssJs$PrezzeeRibbon.px(32)),
              BsCssJs$PrezzeeRibbon.selector("svg", [BsCssJs$PrezzeeRibbon.color(iconCardTheme.svgColour)]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [BsCssJs$PrezzeeRibbon.padding4(BsCssJs$PrezzeeRibbon.px(20), BsCssJs$PrezzeeRibbon.px(20), BsCssJs$PrezzeeRibbon.px(30), BsCssJs$PrezzeeRibbon.px(20))]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(20))])
            ]);
}

var Styles = {
  container: container
};

function IconCard(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    container(theme, props.themeType),
                    className$1
                  ])
            });
}

var make = IconCard;

export {
  Styles ,
  make ,
}
/* classnames Not a pure module */
